import {
  Col,
  Dropdown,
  Layout,
  Menu,
  Row,
  Avatar,
  Modal,
  Typography,
  Tooltip,
} from "antd";
import React, { useState } from "react";
import { CaretDownOutlined } from "@ant-design/icons";
import { IProfile } from "../common";

type Props = {
  onLogout: () => void;
  profile?: IProfile;
};

export const MainHeader: React.FC<Props> = ({ onLogout, profile }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const menu = (
    <Menu>
      <Menu.Item key="profile" onClick={showModal}>
        Profile
      </Menu.Item>
      <Menu.Item key="logout" onClick={() => onLogout()}>
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Modal
        title="บัญชีของฉัน"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={false}
      >
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <Typography className="text-[18px]">{`ชื่อโปรไฟล์ :`}</Typography>
          </Col>
          <Col span={12}>
            <Typography className="text-[18px]">{`${profile?.name} ${profile?.surname}`}</Typography>
          </Col>
          <Col span={8}>
            <Typography className="text-[18px]">{`บัตรประชาชน :  `}</Typography>
          </Col>
          <Col span={12}>
            <Typography className="text-[18px]">{` ${profile?.id_card_number}`}</Typography>
          </Col>
          <Col span={8}>
            <Typography className="text-[18px]">{`เบอรโทร : `}</Typography>
          </Col>
          <Col span={12}>
            <Typography className="text-[18px]">{`${profile?.users[0].phonenumber}`}</Typography>
          </Col>
          <Col span={8}>
            <Typography className="text-[18px]">{`อีเมล :`}</Typography>
          </Col>
          <Col span={8}>
            <Typography className="text-[18px]">{`${profile?.users[0].email}`}</Typography>
          </Col>
        </Row>
      </Modal>
      <Layout.Header className="p-0 border-b border-[#F0F0F0] bg-[#005EA6]">
        <Row className="flex justify-end pl-[50px]">
          <Col className="mr-[20px]">
            <Tooltip placement="bottom" title={profile?.name}>
              <Avatar
                className=" items-center bg-white text-[#005EA6] align-middle size-large gap-1 ml-auto"
              >
                {profile ? profile?.name : null}
              </Avatar>
            </Tooltip>
          </Col>
          <Col className="mr-[20px]">
            <Dropdown overlay={menu}>
              <CaretDownOutlined className="text-white" />
            </Dropdown>
          </Col>
        </Row>
      </Layout.Header>
    </>
  );
};